import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ManagementTypes } from '../../../utils/ManagementTypes';
import exportToExcel from '../../../utils/convertJsonToExcel.js';
import generatePassword from "../../../utils/generatePassword.js"
import {
  Paper,
  Table,
  TableCell,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import Skeleton from "@mui/material/Skeleton";
import { sendEmailEvents } from "../../../store/action/communicationChannel";
import { CheckPersonExistence, createPerson ,createCommunicationChannel,AddCommunicationChannelToParty ,getPersonDetails ,updatePerson ,updateCommunicationChannel, deletePerson } from "../../../store/action/party.js";
import { createUser, AddUserGroupToUser, getUserGroups, getAllUsers, deleteUser, updateUser, sendNewPasswordEmail, getAllAuthorities, addAuthorityToUser, checkDaaqExist, createDAAQ, addDAAQToUser } from "../../../store/action/user.js";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { styled } from '@mui/material/styles';
import Switch from "@material-ui/core/Switch";
import "./expert.css";
import { useDispatch } from "react-redux";
import DialogContentText from "@mui/material/DialogContentText";
import {
  Accordion,
  AccordionPanel,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import Autocomplete from "@mui/material/Autocomplete";
import {getAllInspector , createInspector , addCaracteristiqueToInspector , deleteInspector ,removeCaracteristiqueFromInspector} from "../../../store/action/inspectionMission";
import Slide from "@mui/material/Slide";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsThreeDots } from "react-icons/bs";
import {validateInput} from "./../../../utils/inputValidation"
import ErrorsAlert from "../../../utils/errorsAlert";
 
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },

  tableSortLabel: {
    color: "rgba(32, 29, 35, 1)",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    padding: "5px 10px",
  },
  dateContainer: {
    border: "none",
    outline: "none",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
  },
  inputContainer: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "34px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  inputContainer2: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "250px",
    height: "30px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(60, 101, 86, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  autocompleteTag: {
    fontFamily: "Poppins, sans-serif",
    backgroundColor: "rgba(240, 243, 199, 1)",
    color: "rgba(60, 101, 86, 1)",
    border: "none",
    fontSize: "0.75rem",
    padding: "2px 6px",
    alignItems: "center",
    justifyContent: "center",
    margin: "2px",
    borderRadius: "16px",
    display: "inline-block",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  taskNameColumn: {
    width: "114px",
    height: "20px",
    gap: "0px",
    fontFamily: "Poppins",
    fontSize: "10.17px",
    fontWeight: 500,
    textAlign: "left",
    color: "rgba(187, 200, 8, 1)",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tableContent: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 400,
    //lineHeight: 19.6,
    textAlign: "left",
    color: "rgba(32, 29, 35, 0.8)",
    paragraph: {
      lineHeight: "32.69px",
    },
  },
  sinistres: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  naText: {
    color: "rgb(145, 145, 145)",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    border: "none",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2, 4, 3),
    width: "459px",
    height: "175px",
  },
  modalTitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "21px",
    textAlign: "left",
    marginBottom: "16px",
  },
  // dialogTitle: {
  //   fontFamily: "Poppins",
  //   fontWeight: 500,
  //   fontSize: 15,
  //   color: "rgba(63, 66, 84, 1)",
  //   backgroundColor: "white",
  //   borderBottom: "1px solid #E5EAEE",
  // },
  line: {
    height: "2px",
    backgroundColor: "rgba(243, 246, 249, 1)",
    width: "100%",
    marginBottom: "16px",
  },
  selectModal: {
    width: "400px",
    height: "36px",
    borderRadius: "4px",
    border: "1px solid rgba(222, 222, 222, 1)",
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "rgb(255, 54, 54)",
    backgroundColor: " rgb(255, 229, 229)",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  ExportStyle: {
    border: "0.96px solid rgba(187, 200, 8, 1)",
    color: "rgba(187, 200, 8, 1)",
    width: "64px",
    height: "27px",
    fontFamily: "Poppins",
    fontSize: "12.76px",
    fontWeight: 400,
    lineHeight: "19.14px",
    background: "rgba(255, 255, 255, 1)",
    margin: "0 1rem",
    cursor: "pointer",
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "64px",
    height: "27px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
    cursor: "pointer",
  },
  TextContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 15px",
  },
  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 400,
    color: "rgba(70, 78, 95, 1)",
  },
  cardValue: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(24, 28, 50, 1)",
    textAlign: "Right",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    padding: "5px",
    width: "240px",
    height: "36px",
    borderRadius: "4px",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    width: "100%",
    height: "680px",
    border: "0.61px solid rgba(226, 217, 239, 1)",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "34px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  selectInputDialog: {
    width: "100%",
    border: "0",
    padding: "5px",
    background: "rgba(243, 246, 249, 1)",
    height: "34px",
    borderRadius: 5,
    alignItems: 'center', // Vertically center the text
    justifyContent: 'center', // Horizontally center the text

  },
  selectInputFiltre: {
    width: "100%",
    border: "0",
    height: "34px",
    borderRadius: 5,
    alignItems: 'center', // Vertically center the text
    justifyContent: 'center', // Horizontally center the text

  },
  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  optionItem: {
    width: "100%",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    specialInput: {
      color: "rgba(24, 28, 50, 0.58)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: 500,
      textAlign: "right",
      backgroundColor: "rgba(243, 246, 249, 1)",
      border: "none",
      width: "209px",
      height: "28px",
    },
  },
}));
export default function UsersList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [managementTypes, setManagementTypes] = useState([]);
  const [governorates, setGovernorates] = useState([]);
  const [typologies, setTypologies] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0); 
  const [nomFiltre, setNomFiltre] = useState("");
  const [prenomFiltre, setPrenomFiltre] = useState("");
  const [nomGroup, setNomGroup] = useState([]);
  const [showLockedOnly, setShowLockedOnly] = useState(false);
  const [openUnlockDialog, setOpenUnlockDialog] = useState(false);
  const [userToUnlock, setUserToUnlock] = useState(null);
  const [inspectorsData , setInspectorsData] = useState([]);
  const [inspectorsFilter, setInspectorsFilter] = useState([]);
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [currentExpertId, setCurrentExpertId] = useState(null);
  const [open, setOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [identity, setIdentity] = useState("");
  const [codeTVA, setCodeTVA] = useState("");
  const [selectedManagementTypes, setSelectedManagementTypes] = useState([]);
  const [selectedGovernorates, setSelectedGovernorates] = useState([]);
  const [delegationsOptions, setDelegationsOptions] = useState([]);
  const [selectedDelegations, setSelectedDelegations] = useState([]);
  const [selectedTypologie, setSelectedTypologie] = useState([]);

  const [selectedExpertEdit, setSelectedExpertEdit] = useState(null);
  const [expertToDelete, setExpertToDelete] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [detail , setDetail] = useState(false);
  const [errors, setErrors] = useState([]);


  function handlePhoneNumberChange(event) {
    const allowedChars = /^[0-9]+$/;
    const newValue = event.target.value.replace(/[^0-9]/g, "");

    if (newValue.length > 9) {
      return;
    }
    setPhoneNumber(newValue);
  }

  const truncateLabel = (label) =>
    label.length > 14 ? `${label.substring(0, 12)}..` : label;

  const TUNISIAN_DELEGATIONS = {
    Tunis: [
      "Bab Bhar",
      "Bab Souika",
      "Carthage",
      "El Menzah",
      "El Ouardia",
      "Ettahrir",
      "Ezzouhour",
      "Hrairia",
      "Jebel Jelloud",
      "La Goulette",
      "La Marsa",
      "Le Bardo",
      "Le Kram",
      "Médina",
      "Séjoumi",
      "Sidi El Béchir",
      "Sidi Hassine",
    ],
    Ariana: [
      "Ariana Ville",
      "Ettadhamen",
      "Kalâat el-Andalous",
      "Mnihla",
      "Raoued",
      "Sidi Thabet",
      "Soukra",
    ],
    "Ben Arous": [
      "Ben Arous",
      "Bou Mhel",
      "El Mourouj",
      "Ezzahra",
      "Fouchana",
      "Hammam Chott",
      "Hammam Lif",
      "Mégrine",
      "Mohamedia",
      "Mornag",
      "Nouvelle Médina",
      "Radès",
    ],
    Manouba: [
      "Borj El Amri",
      "Djedeida",
      "Douar Hicher",
      "El Batan",
      "La Manouba",
      "Mornaguia",
      "Oued Ellil",
      "Tebourba",
    ],
    Nabeul: [
      "Béni Khiar",
      "Bou Argoub",
      "Dar Chaâbane El Fehri",
      "El Haouaria",
      "Grombalia",
      "Hammam Ghezèze",
      "Hammamet",
      "Kelibia",
      "Korba",
      "Menzel Bouzelfa",
      "Menzel Temime",
      "Nabeul",
      "Soliman",
      "Takelsa",
    ],
    Zaghouan: [
      "Bir Mcherga",
      "El Fahs",
      "Nadhour",
      "Saouaf",
      "Zaghouan",
      "Zriba",
    ],
    Bizerte: [
      "Bizerte Nord",
      "Bizerte Sud",
      "El Alia",
      "Ghar El Melh",
      "Ghezala",
      "Joumine",
      "Mateur",
      "Menzel Bourguiba",
      "Menzel Jemil",
      "Ras Jebel",
      "Sejnane",
      "Tinja",
      "Utique",
    ],
    Béja: [
      "Amdoun",
      "Béja Nord",
      "Béja Sud",
      "Goubellat",
      "Medjez El Bab",
      "Nefza",
      "Teboursouk",
      "Testour",
      "Thibar",
    ],
    Jendouba: [
      "Aïn Draham",
      "Balta-Bou Aouane",
      "Bou Salem",
      "Fernana",
      "Ghardimaou",
      "Jendouba Nord",
      "Jendouba Sud",
      "Oued Mliz",
      "Tabarka",
    ],
    Kef: [
      "Dahmani",
      "Jérissa",
      "Kef Est",
      "Kef Ouest",
      "Kalaat Khasba",
      "Kalaat Senan",
      "Nebeur",
      "Sakiet Sidi Youssef",
      "Tajerouine",
    ],
    Siliana: [
      "Bargou",
      "Bou Arada",
      "El Krib",
      "Gaâfour",
      "Kesra",
      "Makthar",
      "Rouhia",
      "Sidi Bou Rouis",
      "Siliana Nord",
      "Siliana Sud",
    ],
    Sousse: [
      "Akouda",
      "Bouficha",
      "Enfida",
      "Hammam Sousse",
      "Hergla",
      "Kalâa Kebira",
      "Kalâa Seghira",
      "Kondar",
      "Msaken",
      "Sidi Bou Ali",
      "Sidi El Hani",
      "Sousse Jawhara",
      "Sousse Médina",
      "Sousse Riadh",
      "Sousse Sidi Abdelhamid",
    ],
    Monastir: [
      "Bekalta",
      "Bembla",
      "Beni Hassen",
      "Jemmal",
      "Ksar Hellal",
      "Ksibet el-Médiouni",
      "Lamta",
      "Moknine",
      "Monastir",
      "Sahline",
      "Sayada-Lamta-Bou Hajar",
      "Zéramdine",
    ],
    Mahdia: [
      "Bou Merdes",
      "Chebba",
      "Chorbane",
      "El Jem",
      "Essouassi",
      "Hebira",
      "Ksour Essef",
      "Mahdia",
      "Melloulèche",
      "Ouled Chamekh",
      "Sidi Alouane",
    ],
    Kairouan: [
      "Bou Hajla",
      "Chebika",
      "Echrarda",
      "El Alâa",
      "Haffouz",
      "Hajeb El Ayoun",
      "Kairouan Nord",
      "Kairouan Sud",
      "Nasrallah",
      "Oueslatia",
      "Sbikha",
    ],
    Kasserine: [
      "El Ayoun",
      "Ezzouhour",
      "Fériana",
      "Foussana",
      "Haïdra",
      "Hassi El Ferid",
      "Jedelienne",
      "Kasserine Nord",
      "Kasserine Sud",
      "Majel Bel Abbès",
      "Sbiba",
      "Sbeitla",
      "Thala",
    ],
    "Sidi Bouzid": [
      "Bir El Hafey",
      "Cebbala Ouled Asker",
      "Jilma",
      "Meknassy",
      "Menzel Bouzaiane",
      "Ouled Haffouz",
      "Regueb",
      "Sidi Ali Ben Aoun",
      "Sidi Bouzid Est",
      "Sidi Bouzid Ouest",
      "Souk Jedid",
    ],
    Sfax: [
      "Agareb",
      "Bir Ali Ben Khalifa",
      "El Amra",
      "El Ghraiba",
      "El Hencha",
      "Jebiniana",
      "Kerkennah",
      "Mahrès",
      "Sakiet Eddaïer",
      "Sakiet Ezzit",
      "Sfax Médina",
      "Sfax Ouest",
      "Sfax Sud",
      "Skhira",
      "Thyna",
    ],
    Gabès: [
      "El Hamma",
      "Gabès Médina",
      "Gabès Ouest",
      "Gabès Sud",
      "Ghannouch",
      "Mareth",
      "Matmata",
      "Menzel Habib",
      "Nouvelle Matmata",
    ],
    Medenine: [
      "Ben Gardane",
      "Beni Khedache",
      "Djerba",
      "Medenine Nord",
      "Medenine Sud",
      "Sidi Makhlouf",
      "Zarzis",
    ],
    Tataouine: [
      "Bir Lahmar",
      "Dehiba",
      "Ghomrassen",
      "Remada",
      "Smâr",
      "Tataouine Nord",
      "Tataouine Sud",
    ],
    Gafsa: [
      "Belkhir",
      "El Guettar",
      "El Ksar",
      "Gafsa Nord",
      "Gafsa Sud",
      "Mdhilla",
      "Metlaoui",
      "Moularès",
      "Redeyef",
      "Sened",
    ],
    Tozeur: ["Degache", "Hazoua", "Nefta", "Tamaghza", "Tozeur"],
    Kébili: ["Douz", "Faouar", "Kébili Nord", "Kébili Sud", "Souk Lahad"],
  };
  // Alias : la liste des gouvernorats et les données existantes utilisent ces orthographes
  TUNISIAN_DELEGATIONS.Mednine = TUNISIAN_DELEGATIONS.Medenine;
  TUNISIAN_DELEGATIONS.Kebili = TUNISIAN_DELEGATIONS.Kébili;
  const headRows = [
    { id: "nom", align: "left", label: "Nom & Prénom", width: "15%" },
    { id: "email", align: "left", label: "Email", width: "15%" },
    { id: "tel", align: "left", label: "Tél", width: "10%" },
    {
      id: "groups",
      align: "left",
      label: "Périmétre",
      width: "20%",
    },
    {
        id: "region",
        align: "left",
        label: "Région/Gouvernorat",
        width: "35%",
      },
    { id: "", align: "center", label: "", width: "5%" },
  ];
  
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
  const phoneRegex = /^[0-9]{8}$/;
  const handleDropdownClick = (id) => { 
    setDropdownVisible(!dropdownVisible);
    setCurrentExpertId(id)
};
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };
  const handleNomGroupeChange = (event, newValue) => {
    setNomGroup(newValue);
  };
  const handleNomChange = (e) =>
    setNomFiltre(e.target.value.toLowerCase());
  const handlePrenomChange = (e) =>
    setPrenomFiltre(e.target.value.toLowerCase());
  const handleClickDeleteOpen = (user) => {
    setExpertToDelete(user);
    setOpenConfirm(true);
  };
  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setExpertToDelete(null);
  };
  const fetchInspectors = async () => {
    // Charge aussi les comptes MS_USER pour connaitre l'etat verrouille de chaque expert
    const [inspectors, allUsers] = await Promise.all([
      dispatch(getAllInspector()),
      dispatch(getAllUsers()),
    ]);
    const usersByParty = new Map(
      (Array.isArray(allUsers) ? allUsers : [])
        .filter((u) => u.associatedPartyUid)
        .map((u) => [u.associatedPartyUid, u])
    );
    const enriched = (Array.isArray(inspectors) ? inspectors : []).map((inspector) => {
      const userAccount = usersByParty.get(inspector.associatedParty) || null;
      return { ...inspector, userAccount, isLocked: userAccount?.accountLocked === true };
    });
    // inspectorsFilter est recalculé par le useEffect de filtrage (dépendance inspectorsData)
    setInspectorsData(enriched);
    setLoading(false);
  };

  const handleLockedSwitchChange = (event) => {
    setShowLockedOnly(event.target.checked);
  };

  const handleOpenUnlockDialog = (user) => {
    setUserToUnlock(user);
    setOpenUnlockDialog(true);
  };

  const handleCloseUnlockDialog = () => {
    setOpenUnlockDialog(false);
    setUserToUnlock(null);
  };

  const handleConfirmUnlock = async () => {
    const account = userToUnlock?.userAccount;
    if (!account?._id) {
      toast.error("Utilisateur introuvable.");
      return;
    }

    try {
      setIsRequestInProgress(true);

      // Version MAE : déverrouillage via MS_USER (plus de backend starex)
      await updateUser(account._id, {
        firstName: account.firstName,
        lastName: account.lastName,
        email: account.email,
        accountExpired: account.accountExpired || false,
        accountLocked: false,
        phoneNumber: account.phoneNumber,
        numberOfAttempts: 0,
      });
      await sendNewPasswordEmail(account._id);

      toast.success("Compte déverrouillé avec succès. Un email avec le nouveau mot de passe a été envoyé.");
      handleCloseUnlockDialog();
      fetchInspectors();
    } catch (error) {
      console.error("Erreur lors du déverrouillage de l'utilisateur:", error);
      toast.error("Erreur lors du déverrouillage de l'utilisateur.");
    } finally {
      setIsRequestInProgress(false);
    }
  };
  const filterInspectors = () => {
    let filteredInspectors = inspectorsData;
  
    if (nomFiltre) {
      filteredInspectors = filteredInspectors.filter((user) =>
        user.personDetails?.name?.toLowerCase().includes(nomFiltre)
      );
    }
  
    if (prenomFiltre) {
      filteredInspectors = filteredInspectors.filter((user) =>
        user.personDetails?.lastName?.toLowerCase().includes(prenomFiltre)
      );
    }
  
    if (nomGroup.length > 0)  {
      filteredInspectors = filteredInspectors.filter(
        (inspector) =>
          inspector.inspectorCaracteristiques?.some(
            (caracteristique) =>
              nomGroup.some(filterGroup =>
                caracteristique.key === "SCOPE" && caracteristique.value === filterGroup.label
              )

          )
        );

    }

    if (showLockedOnly) {
      filteredInspectors = filteredInspectors.filter((inspector) => inspector.isLocked === true);
    }

    setInspectorsFilter(filteredInspectors);
  };
  

  
  const getPhone = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
    const phoneValue = Channel ? Channel.communicationChannel.value : "N/A"
    return phoneValue
  }

  const getEmail = (partyCommunicationChannels) => {
    const Channel = partyCommunicationChannels?.find(party => party.communicationChannel?.type === "EMAILCONTACT" &&  party.status === "ACTIVE");
    const emailValue = Channel ? Channel.communicationChannel.value : "N/A"
    return emailValue
  }

 

  const handleAddExpert = () => { 
    setSelectedExpertEdit();
    setDetail(false);
    setLastName('');
    setFirstName('');
    setPhoneNumber('');
    setEmail('');
    setIdentity(''); 
    setCodeTVA(''); 
    setIsEditing(false);
    setSelectedManagementTypes([]);
    setSelectedGovernorates([]);
    setSelectedDelegations([]);
    setSelectedTypologie([]);
    setOpen(!open);
  };
 
  const handleClickEditOpen = (expert) => {
    console.log("Edit user : ", expert);
    setDetail(false);
    setSelectedExpertEdit(expert);
    setIsEditing(true);
    setLastName(expert?.personDetails?.lastName);
    setFirstName(expert?.personDetails?.name);
    setPhoneNumber(getPhone(expert?.personDetails?.partyCommunicationChannels) );
    setEmail(getEmail(expert?.personDetails?.partyCommunicationChannels) );
    setIdentity(expert?.personDetails?.code); 
    // Le code TVA est une caractéristique de l'inspecteur, pas un champ de la personne
    setCodeTVA(expert?.inspectorCaracteristiques?.find((c) => c.key === "CODETVA")?.value ?? '');
    const updatedManagementTypes = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "SCOPE")
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
      
    setSelectedManagementTypes(updatedManagementTypes);
    const updateGovernorates = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "GOUVERNORAT")
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
    const newDelegations = updateGovernorates
      .flatMap((gov) => TUNISIAN_DELEGATIONS[gov.label] || [])
      .sort();
    setDelegationsOptions(newDelegations);
    setSelectedGovernorates(updateGovernorates);
    const updateDelegations = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "REGION") 
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
    setSelectedDelegations(updateDelegations);
    const updateTypologie = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "MISSIONTYPE")
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
    setSelectedTypologie(updateTypologie);
    setOpen(!open);
    
  };
  const handleClickDetailOpen = (expert) => {
    console.log("Edit user : ", expert);
    setDetail(true);
    setSelectedExpertEdit(expert);
    setIsEditing(true);
    setLastName(expert?.personDetails?.lastName);
    setFirstName(expert?.personDetails?.name);
    setPhoneNumber(getPhone(expert?.personDetails?.partyCommunicationChannels) );
    setEmail(getEmail(expert?.personDetails?.partyCommunicationChannels) );
    setIdentity(expert?.personDetails?.code); 
    // Le code TVA est une caractéristique de l'inspecteur, pas un champ de la personne
    setCodeTVA(expert?.inspectorCaracteristiques?.find((c) => c.key === "CODETVA")?.value ?? '');
    const updatedManagementTypes = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "SCOPE")
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
      
    setSelectedManagementTypes(updatedManagementTypes);
    const updateGovernorates = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "GOUVERNORAT")
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
    const newDelegations = updateGovernorates
      .flatMap((gov) => TUNISIAN_DELEGATIONS[gov.label] || [])
      .sort();
    setDelegationsOptions(newDelegations);
    setSelectedGovernorates(updateGovernorates);
    const updateDelegations = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "REGION") 
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
    setSelectedDelegations(updateDelegations);
    const updateTypologie = expert.inspectorCaracteristiques
    .filter((caracteristique) => caracteristique.key === "MISSIONTYPE")
    .map((caracteristique) => ({
      label: caracteristique.value,
    }))
    setSelectedTypologie(updateTypologie);
    setOpen(!open);
    
  };
  const handleManagementTypesChange = (event, newValue) => {
    setSelectedManagementTypes(newValue);
  };
   
  const handleGovernorates = (event, newValue) => {
    setSelectedGovernorates(newValue);
    const newDelegations = newValue
      .flatMap((gov) => TUNISIAN_DELEGATIONS[gov.label] || [])
      .sort(); // Optional: Sort delegations alphabetically
    setDelegationsOptions(newDelegations);
    // Ne garder que les régions encore rattachées à un gouvernorat sélectionné
    setSelectedDelegations((current) =>
      current.filter((delegation) => newDelegations.includes(delegation.label))
    );
  };

  const handleDelegations = (event, newValue) => {
    setSelectedDelegations(newValue);
  };
  const handleTypologieChange = (event, newValue) => {
    setSelectedTypologie(newValue);
  };


  // Un expert MAE = personne (ms-party) + inspecteur (ms-inspection) + compte MS_USER du groupe EXPERT_group
  const EXPERT_GROUP_LABEL = 'EXPERT_group';
  // EXPERT_group ne porte aucune autorisation ni DAAQ (prod et préprod MAE) : chaque expert reçoit
  // ces 5 autorisations personnelles (les 135 experts de prod les ont toutes, et seulement celles-ci)
  // et un DAAQ /claim/classique/*/*/NOM PRENOM, même segment expert que celui écrit par l'ETL sur
  // les sinistres. Sans eux : page blanche à la connexion (aucune route accessible) et aucun dossier.
  const EXPERT_AUTHORITIES = ['VIEW_CLAIM_LIST', 'VIEW_TO_DO_LIST', 'ADD_PICTURES', 'ADD_DOCUMENTS', 'DELETE_DOCUMENT'];
  const expertDaaqPath = (name, surname) =>
    `/claim/classique/*/*/${`${name || ''} ${surname || ''}`.replace(/[/\\?#]/g, ' ').replace(/\s+/g, ' ').trim().toUpperCase()}`;

  // Autorisations + DAAQ du compte expert (création). Lève une erreur si un élément manque :
  // l'appelant annule alors toute la création (personne, inspecteur, compte).
  const provisionExpertUser = async (user, name, surname) => {
    const authorities = await dispatch(getAllAuthorities());
    const list = Array.isArray(authorities) ? authorities : (authorities?.authorities || []);
    for (const label of EXPERT_AUTHORITIES) {
      const authority = list.find((a) => a.label === label);
      if (!authority?.uid) throw new Error(`Autorisation ${label} introuvable dans le référentiel`);
      const added = await dispatch(addAuthorityToUser(user._id, authority.uid));
      if (!added) throw new Error(`Échec de l'ajout de l'autorisation ${label}`);
    }
    const readDAAQ = expertDaaqPath(name, surname);
    let daaq = await dispatch(checkDaaqExist(readDAAQ));
    if (!daaq?.uid) daaq = await dispatch(createDAAQ({ label: readDAAQ, readDAAQ, updateDAAQ: readDAAQ }));
    if (!daaq?.uid) throw new Error(`Échec de la création du DAAQ ${readDAAQ}`);
    const linked = await dispatch(addDAAQToUser(user._id, daaq.uid));
    if (!linked) throw new Error(`Échec du rattachement du DAAQ ${readDAAQ}`);
  };

  const getPasswordExpirationDate = () => {
    const currentDate = new Date();
    currentDate.setFullYear(currentDate.getFullYear() + 1);
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const handleSubmitAdd = async () => {

      try {
        // Validation: Check for required fields
      if (!lastName || !firstName || !phoneNumber || !email  || !identity || selectedManagementTypes.length === 0 || selectedGovernorates.length === 0 || selectedTypologie.length === 0) {
        alert("Veuillez remplir tous les champs obligatoires  .");
        return;
      }
      if(!emailRegex.test(email) ) // Check if email is valid
      {
        alert("L'adresse e-mail saisie est invalide. Veuillez entrer une adresse e-mail valide.");
        return;
      }
      if (!phoneRegex.test(phoneNumber)) { // Check if phone number is valid
        alert("Le numéro de téléphone saisi est invalide. Veuillez entrer un numéro de téléphone valide (10 chiffres).");
        return;
      }
      setIsRequestInProgress(true);  

          const partyData = {
            "birthDate": "1995-01-01",
            "name": firstName,
            "daaq":"/",
            "code":identity,
            "lastName": lastName,
            "identityNumber": identity,
            "additionalData":{
            }
          }
          const communicationChannels=[ {
              "type": "PHONECONTACT",
              "value": phoneNumber
           },
           {
            "type": "EMAILCONTACT",
            "value": email
            }];
          
          // Version MAE : pas d'appel au backend starex — mot de passe généré une seule fois
          const expertPassword = generatePassword();
          const userData = {
            "username": firstName.replaceAll(' ', '') + "_" + lastName.replaceAll(' ', ''),
            "firstName": firstName,
            "lastName": lastName,
            "email": email,
            "accountExpired": false,
            "accountLocked": false,
            "phoneNumber": phoneNumber,
            "password": expertPassword,
            "passwordExpirationDate": getPasswordExpirationDate(),
            "associatedPartyUid": ""
          }

          let personApi = await CheckPersonExistence(partyData);

          if (personApi) {
            toast.error("L'expert existe déjà");
            setIsRequestInProgress(false);
            return;
          }
          personApi = await createPerson(partyData);
          if (!personApi) {
            throw new Error('Error Create Person');
          }
          userData.associatedPartyUid = personApi.uid;
          let newInspectors = null;
          let newUser = null;

            try {
              await Promise.all(communicationChannels.map(async (channelData) => {
                const channel = await dispatch(createCommunicationChannel(channelData));
                await AddCommunicationChannelToParty(personApi.uid, channel._id);
              }));

              const inspectors = {
                "associatedParty": personApi.uid,
                // MAE : plus de workspace starex — valeur neutre
                "inspectorWorkspaceId": "0000"
              }

              newInspectors = await dispatch(createInspector(inspectors));

              if (!newInspectors || !newInspectors._id) {
                throw new Error("Failed to retrieve new newInspectors");
              }

              const characteristics = [
                { key: 'SCOPE', values: selectedManagementTypes },
                { key: 'GOUVERNORAT', values: selectedGovernorates },
                { key: 'REGION', values: selectedDelegations },
                { key: 'MISSIONTYPE', values: selectedTypologie },
              ];

              for (const { key, values } of characteristics) {
                for (const { label } of values) {
                  await dispatch(addCaracteristiqueToInspector(newInspectors._id, { key, value: label }));
                }
              }
              if (codeTVA) {
                await dispatch(addCaracteristiqueToInspector(newInspectors._id, { key: 'CODETVA', value: codeTVA }));
              }

              // Compte de connexion MS_USER rattaché au groupe EXPERT_group
              newUser = await dispatch(createUser(userData));
              if (!newUser || !newUser._id) {
                throw new Error("Failed to create expert user account");
              }
              const groups = await dispatch(getUserGroups());
              const expertGroup = Array.isArray(groups) ? groups.find((g) => g.label === EXPERT_GROUP_LABEL) : null;
              if (expertGroup) {
                await dispatch(AddUserGroupToUser(newUser._id, expertGroup.uid));
              } else {
                console.error(`Groupe ${EXPERT_GROUP_LABEL} introuvable — expert créé sans groupe`);
              }
              await provisionExpertUser(newUser, firstName, lastName);

              let dataEmail = {
                "templateId": "674e19a1a4d434916dc9be54",
                "email": userData.email,
                  "parameters": {
                    prenom: lastName,
                    nom: firstName,
                    username: userData.username,
                    password: expertPassword,
                  },
                };
              const emailEvents = await  dispatch(sendEmailEvents(dataEmail));
              if(emailEvents){
                console.log("Email sent successfully");
              }

            } catch (error) {
              console.error("Failed to create expert:", error);
              toast.error("Échec de la création de l'expert");
              // Rollback : sans cela la personne orpheline bloque toute nouvelle tentative (« existe déjà »)
              try {
                if (newUser?._id) {
                  await dispatch(deleteUser(newUser._id));
                }
                if (newInspectors?._id) {
                  await dispatch(deleteInspector(newInspectors._id));
                }
                await deletePerson(personApi.uid);
              } catch (rollbackError) {
                console.error("Failed to rollback expert creation:", rollbackError);
              }
              setIsRequestInProgress(false);
              return;
            }
            setIsRequestInProgress(false); // Set loading state to false once the process is complete
            toast.success("Expert créé avec succès");
            setOpen(false);
            fetchInspectors()

      } catch (error) {
        console.error("Unexpected error during submit:", error);
        toast.error("Échec de la création de l'expert");
        setIsRequestInProgress(false);
      }
    };
    function handleExport() {
      if (!Array.isArray(inspectorsFilter)) {
          console.error("inspectorsFilter is not an array");
          return;
      }
  
      const dataExportToExcel = inspectorsFilter.map(data => {
          const { personDetails, inspectorCaracteristiques } = data;
  
          const getCommunicationChannelValue = (type) => 
              personDetails.partyCommunicationChannels.find(channel => channel.communicationChannel.type === type)?.communicationChannel.value || null;
  
          const getInspectorCharacteristicValues = (key) => {
              const values = inspectorCaracteristiques
                  .filter(item => item.key === key)
                  .map(item => item.value);
              return values.length > 0 ? values.join(' ; ') : null;  
          };
  
          return {
              name: personDetails.name,
              lastName: personDetails.lastName,
              identityNumber: personDetails.identityNumber,
              EMAILCONTACT: getCommunicationChannelValue("EMAILCONTACT"),
              PHONECONTACT: getCommunicationChannelValue("PHONECONTACT"),
              MISSIONTYPE: getInspectorCharacteristicValues("MISSIONTYPE"),
              GOUVERNORAT: getInspectorCharacteristicValues("GOUVERNORAT"),
              REGION: getInspectorCharacteristicValues("REGION"),
              SCOPE: getInspectorCharacteristicValues("SCOPE")
          };
      });
  
      exportToExcel(dataExportToExcel, 'Experts.xlsx');
  }
  const handleSubmitEdit = async () => {
          // La validation reste hors du try : un return dans le try déclenchait le finally qui fermait le dialogue
          if (!lastName || !firstName || !phoneNumber || !email  || !identity || selectedManagementTypes.length === 0 || selectedGovernorates.length === 0 || selectedTypologie.length === 0) {
            alert("Veuillez remplir tous les champs obligatoires  .");
            return;
          }
          if(!emailRegex.test(email) ) // Check if email is valid
          {
            alert("L'adresse e-mail saisie est invalide. Veuillez entrer une adresse e-mail valide.");
            return;
          }
          if (!phoneRegex.test(phoneNumber)) { // Check if phone number is valid
            alert("Le numéro de téléphone saisi est invalide. Veuillez entrer un numéro de téléphone valide (10 chiffres).");
            return;
          }

        try {
          setIsRequestInProgress(true);
          const partyData = {
            "birthDate": "1995-01-01",
            "name": firstName,
            "daaq":"/",
            "code":identity,
            "lastName": lastName,
            "identityNumber": identity,
            "additionalData":{
            }
          }
          const communicationChannels=[ {
              "type": "PHONECONTACT",
              "value": phoneNumber
           },
           {
            "type": "EMAILCONTACT",
            "value": email
            }];
          
          const person = await getPersonDetails(selectedExpertEdit.associatedParty);
          if (!person) {
            throw new Error("Person not found");
          }
          for (const channel of communicationChannels) {
            const existingChannel = (person.partyCommunicationChannels || []).find(
              (ch) => ch.communicationChannel?.type === channel.type
            );

            if (!existingChannel) {
              const channelData = await dispatch(createCommunicationChannel(channel));
              await AddCommunicationChannelToParty(person.uid, channelData._id);
            } else if (existingChannel.communicationChannel.value !== channel.value) {
              // updateCommunicationChannel est une fonction async simple, pas un thunk : ne pas passer par dispatch
              const updated = await updateCommunicationChannel(existingChannel.communicationChannel._id, channel);
              if (!updated) {
                throw new Error(`Failed to update ${channel.type}`);
              }
            }
          }

          await dispatch(updatePerson(selectedExpertEdit.associatedParty, partyData));

          // Le compte de connexion MS_USER doit suivre les coordonnées de la personne
          const account = selectedExpertEdit.userAccount;
          if (account?._id) {
            const updatedUser = await updateUser(account._id, {
              firstName,
              lastName,
              email,
              phoneNumber,
            });
            if (!updatedUser) {
              throw new Error("Failed to update expert user account");
            }
          }

          const characteristics = [
            { key: 'SCOPE', values: selectedManagementTypes },
            { key: 'GOUVERNORAT', values: selectedGovernorates },
            { key: 'REGION', values: selectedDelegations },
            { key: 'MISSIONTYPE', values: selectedTypologie },
            { key: 'CODETVA', values: codeTVA ? [{ label: codeTVA }] : [] },
          ];
          const managedKeys = characteristics.map(({ key }) => key);

          // Flatten the `characteristics` array into a list of { key, value } objects
          const newCaracteristiques = characteristics.flatMap(({ key, values }) =>
            values.map(({ label }) => ({ key, value: label }))
          );

          // Convert `inspectorCaracteristiques` to a comparable array
          const existingCaracteristiques = selectedExpertEdit.inspectorCaracteristiques.map(({ key, value }) => ({
            key,
            value,
          }));

          // Add new entries
          for (const { key, value } of newCaracteristiques) {
            // Check if the item exists in the existing list
            const exists = existingCaracteristiques.some(
              (item) => item.key === key && item.value === value
            );
            if (!exists) {
              await dispatch(addCaracteristiqueToInspector(selectedExpertEdit._id, { key, value }));
            }
          }

          // Remove outdated entries — uniquement sur les clés gérées par ce formulaire
          for (const { _id, key, value } of selectedExpertEdit.inspectorCaracteristiques) {
            if (!managedKeys.includes(key)) continue;
            const isOutdated = !newCaracteristiques.some(
              (item) => item.key === key && item.value === value
            );
            if (isOutdated) {
              await dispatch(removeCaracteristiqueFromInspector(selectedExpertEdit._id ,_id));
            }
          }

          toast.success("Expert modifié avec succès");
          setOpen(false);
          fetchInspectors();
      } catch (error) {
        console.error("Unexpected error during submit:", error);
        toast.error("Échec de la modification de l'expert");
      } finally {
        setIsRequestInProgress(false);
      }
    };

   const handleConfirmDelete = async () => {
     if (expertToDelete) {
       try {
        setIsRequestInProgress(true);
         await dispatch(deleteInspector(expertToDelete._id));

         // Supprimer aussi le compte MS_USER rattaché à la même partie
         try {
           const allUsers = await dispatch(getAllUsers());
           const expertUser = Array.isArray(allUsers)
             ? allUsers.find((u) => u.associatedPartyUid === expertToDelete.associatedParty)
             : null;
           if (expertUser?._id) {
             await dispatch(deleteUser(expertUser._id));
           }
         } catch (userError) {
           console.error("Failed to delete expert user account:", userError);
         }

         // Supprimer la personne ms-party, sinon la re-création échoue sur « L'expert existe déjà »
         try {
           await deletePerson(expertToDelete.associatedParty);
           toast.success("Expert supprimé avec succès");
         } catch (personError) {
           console.error("Failed to delete expert person:", personError);
           toast.error("Expert supprimé, mais la fiche personne n'a pas pu être supprimée");
         }

         fetchInspectors();
       } catch (error) {
         console.error("Failed to delete Inspector:", error);
         toast.error("Échec de la suppression de l'expert");
       } finally {
         setIsRequestInProgress(false);
         setOpenConfirm(false);
         setExpertToDelete(null);
       }
     }
   };
    
  const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#65C466',
          opacity: 1,
          border: 0,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 13,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

  useEffect(() => {
    // MAE : seul le périmètre CLASSIQUE est proposé
    setManagementTypes(ManagementTypes.filter((t) => t.label === "CLASSIQUE"));
    setGovernorates([
      { label: "Tunis" },
      { label: "Ariana" },
      { label: "Ben Arous" },
      { label: "Manouba" },
      { label: "Nabeul" },
      { label: "Zaghouan" },
      { label: "Bizerte" },
      { label: "Béja" },
      { label: "Jendouba" },
      { label: "Kef" },
      { label: "Siliana" },
      { label: "Sousse" },
      { label: "Monastir" },
      { label: "Mahdia" },
      { label: "Sfax" },
      { label: "Kairouan" },
      { label: "Kasserine" },
      { label: "Sidi Bouzid" },
      { label: "Gabès" },
      { label: "Mednine" },
      { label: "Tataouine" },
      { label: "Gafsa" },
      { label: "Tozeur" },
      { label: "Kebili" }
    ])
    setTypologies([
      { label:"Première Expertise"},
      { label:"Deuxième Expertise"},
      { label:"Contre-Expertise"},
      { label:"Arbitrage"},
      { label:"Rapport De Carrence"},
      { label:"Expertise Judiciare"}
    ])
    fetchInspectors()
  }, [dispatch]);

    useEffect(() => {
        filterInspectors();
    }, [inspectorsData, nomFiltre, prenomFiltre  , nomGroup, showLockedOnly]);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "40px",
            }}
          >
            <div className={classes.titre} style={{ width: "20%" }}>
              Liste des experts
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "80%",
              //  justifyContent: "flex-end",
              }}
            >
              <div
                className={classes.titre}
                style={{ marginRight: "15px", whiteSpace: "nowrap" }}
              >
                Filtrer par
              </div>
                <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                Périmétrer 
                 <Autocomplete
                                      multiple
                                      style={{marginLeft: "5px" }}
                                      name="Typologie"
                                      id="Typologie"
                                      options={managementTypes.map((type) => ({
                                        label: type.label,
                                        value: type,
                                      }))}
                                      value={nomGroup.map((item) => ({
                                        label: item.label,
                                        value: item,
                                      }))}
                                      size="small"
                                      onChange={(event, newValue) => {
                                        handleNomGroupeChange(
                                          null,
                                          newValue.map((item) => item.value)
                                        );
                                      }}
                                      getOptionLabel={(option) => option.label || ""}
                                      renderOption={(props, option) => (
                                        <li
                                          {...props}
                                          className={`${props.className} ${classes.optionItem}`}
                                        >
                                          {option.label}
                                        </li>
                                      )}
                                      renderTags={(tagValue, getTagProps) => {
                                        const visibleTag = tagValue[0];
                                        const hiddenTags = tagValue.slice(1);
                  
                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              flexWrap: "nowrap",
                                              alignItems: "center",
                                            }}
                                          >
                                            {visibleTag && (
                                              <span
                                                {...getTagProps({ index: 0 })}
                                                className={classes.autocompleteTag}
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  backgroundColor: "rgba(240, 243, 199, 1)",
                                                  color: "rgba(60, 101, 86, 1)",
                                                  padding: "2px 6px",
                                                  borderRadius: "12px",
                                                  fontSize: "0.75rem",
                                                  margin: "2px",
                                                }}
                                              >
                                                {truncateLabel(visibleTag.label)}
                                                <span
                                                  className={classes.deleteIcon}
                                                  style={{
                                                    marginLeft: "4px",
                                                    cursor: "pointer",
                                                    color: "rgba(60, 101, 86, 1)",
                                                  }}
                                                  onClick={() => {
                                                    const newValue = tagValue.filter(
                                                      (_, i) => i !== 0
                                                    );
                                                    handleNomGroupeChange(
                                                      null,
                                                      newValue.map((item) => item.value)
                                                    );
                                                  }}
                                                >
                                                  ✕
                                                </span>
                                              </span>
                                            )}
                                            {hiddenTags.length > 0 && (
                                              <span
                                                className={classes.autocompleteTag}
                                                style={{
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  backgroundColor: "rgba(240, 243, 199, 1)",
                                                  color: "rgba(60, 101, 86, 1)",
                                                  padding: "2px 6px",
                                                  borderRadius: "12px",
                                                  fontSize: "0.75rem",
                                                  margin: "2px",
                                                }}
                                                title={hiddenTags
                                                  .map((tag) => tag.label)
                                                  .join(", ")}
                                              >
                                                ... ({hiddenTags.length})
                                              </span>
                                            )}
                                            {tagValue.length > 0 && (
                                              <span
                                                className={classes.deleteAllIcon}
                                                style={{
                                                  marginLeft: "8px",
                                                  cursor: "pointer",
                                                  color: "rgba(60, 101, 86, 1)",
                                                }}
                                                onClick={() => handleNomGroupeChange(null, [])}
                                              >
                                                ✕
                                              </span>
                                            )}
                                          </div>
                                        );
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          className={classes.inputContainer2}
                                            InputProps={{
                                            ...params.InputProps,
                                            disableUnderline: true,
                                            endAdornment: null,
                                          }}
                                        />
                                      )}
                                      sx={{
                                        fontFamily: "Poppins, sans-serif",
                                        "& .MuiOutlinedInput-root": {
                                          p: 1,
                                          height: "fit-content",
                                          backgroundColor: "rgba(243, 246, 249, 1)",
                                          fontSize: "0.75rem",
                                          display: "flex",
                                          fontFamily: "Poppins",
                                          border: "none",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          "& fieldset": {
                                            border: "none",
                                          },
                                        },
                                        "& .MuiAutocomplete-popupIndicator": {
                                          display: "none",
                                        },
                                        "& .MuiAutocomplete-tag": {
                                          bgcolor: "rgba(240, 243, 199, 1)",
                                          color: "rgba(60, 101, 86, 1)",
                                          border: "none",
                                          borderColor: "primary.light",
                                          fontSize: "0.75rem",
                                          padding: "2px 6px",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          margin: "2px",
                                        },
                                        "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                                          color: "rgba(60, 101, 86, 1)",
                                          "&:hover": {
                                            color: "rgba(60, 101, 86, 1)",
                                          },
                                        },
                                      }}
                                      isOptionEqualToValue={(option, value) =>
                                        option.value === value.value
                                      }
                                    />
              </div>  
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                }}
              >
                Nom
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "149px", marginLeft: "10px" }}
                  onChange={handleNomChange}
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                }}
              >
                Prénom
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "149px", marginLeft: "10px" }}
                  onChange={handlePrenomChange}
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                  marginLeft: "1rem",
                  position: "relative",
                  zIndex: 2,
                }}
              >
                Comptes verrouillés
                <StyledSwitch
                  checked={showLockedOnly}
                  onChange={handleLockedSwitchChange}
                  sx={{ ml: 1 }}
                />
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {/* <button
                className={classes.ExportStyle} 
                onClick={handleExport}
              >
                Export
              </button> */}
              <button
                className={classes.ajouterStyle} 
                 onClick={handleAddExpert}
                 name="Ajouter"
              >
                Ajouter
              </button>
            </div>
          </div>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
          >
            <thead>
              <tr>
                {headRows.map((row) => (
                  <TableCell
                    height={"43px"}
                    width={row.width}
                    align={row.align}
                    className={classes.tableHeadRows}
                    key={row.id}
                  >
                    {row.label}
                  </TableCell>
                ))}
              </tr>
            </thead>
            <tbody>
                {loading
                  ? [...Array(10)].map((_, index) => (
                      <tr key={index} style={{ height: "48px" }}>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="left" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                        <TableCell align="center" className={classes.tableCellSmall}>
                          <Skeleton animation="wave" />
                        </TableCell>
                      </tr>
                    ))
                  : (
                    <>
                      {inspectorsFilter != null && inspectorsFilter.length > 0 ? (
                        inspectorsFilter
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((user) => (
                            <tr key={user._id} style={{ height: "48px" }}>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user?.personDetails?.lastName  + " " + user?.personDetails?.name}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {getEmail(user?.personDetails?.partyCommunicationChannels)  }
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {getPhone(user?.personDetails?.partyCommunicationChannels)  }
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user.inspectorCaracteristiques
                                  .filter((group) => group.key === 'SCOPE' && group.value === 'CLASSIQUE') // MAE : seul CLASSIQUE est affiché
                                  .map((group) => (
                                    <span style={{width: "69px",
                                      height: "26px", 
                                      borderRadius: '51px',
                                      background:'rgba(240, 243, 199, 1)',
                                      fontFamily: 'Poppins',
                                      fontSize: '10.69px',
                                      fontWeight: 500,
                                      lineHeight: '16.03px',
                                      textAlign: 'left',
                                      color:'rgba(60, 101, 86, 1)',
                                      padding :'10px',
                                      marginRight: '5px'
                                      }} key={group._id}>{group.value}</span> // Map over filtered entries
                                  ))}
                              </TableCell>
                              <TableCell align="left" className={classes.tableCellSmall}>
                                {user.inspectorCaracteristiques
                                  .filter((group) => group.key === 'GOUVERNORAT' || group.key === 'REGION') // Filter the array
                                  .map((group) => (
                                    <span style={{width: "69px",
                                      height: "26px", 
                                      borderRadius: '51px',
                                      background:'rgba(240, 243, 199, 1)',
                                      fontFamily: 'Poppins',
                                      fontSize: '10.69px',
                                      fontWeight: 500,
                                      lineHeight: '16.03px',
                                      textAlign: 'left',
                                      color:'rgba(60, 101, 86, 1)',
                                      padding :'10px',
                                      marginRight: '5px'
                                      }} key={group._id}>{group.value}</span> // Map over filtered entries
                                  ))}
                              </TableCell>
                              <TableCell align="center" className={classes.tableCellSmall}>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px"
                                  }}>
                                <div style={{ width: "40px", height: "34px" }}>
                                  {user.isLocked && (
                                    <button
                                      style={{
                                        width: "40px",
                                        height: "34px",
                                        borderRadius: "6px",
                                        background: "rgba(240, 243, 199, 1)",
                                        border: 0,
                                        fontFamily: "Poppins",
                                        fontSize: "12px",
                                        fontWeight: 600,
                                        lineHeight: "18px",
                                        color: "rgba(60, 101, 86, 1)",
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                      onClick={() => handleOpenUnlockDialog(user)}
                                      title="Déverrouiller le compte"
                                    >
                                      <VpnKeyIcon style={{ fontSize: 18 }} />
                                    </button>
                                  )}
                                </div>
                              <div style={{display: 'flex', alignItems: 'center'}}>
                                <button
                                  style={{
                                    width: "80px",
                                    height: "34px",
                                    borderRadius: "6px",
                                    background: "rgba(187, 200, 8, 1)",
                                    border: 0,
                                    fontFamily: "Poppins",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                    color: "rgba(255,255,255,1)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClickEditOpen(user)}
                                >
                                  Modifier
                                </button>
                                <button
                                  style={{
                                    width: "80px",
                                    height: "34px",
                                    borderRadius: "6px",
                                    background: "rgba(255, 229, 229, 1)",
                                    border: 0,
                                    fontFamily: "Poppins",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    lineHeight: "18px",
                                    marginLeft: "10px",
                                    color: "rgba(255, 54, 54, 1)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleClickDeleteOpen(user)}
                                >
                                  Supprimer
                                </button>
                              </div>
                              </div>
                              </TableCell>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <TableCell
                            align="center"
                            style={{
                              fontFamily: 'Poppins',
                              fontWeight: 400,
                              fontSize:  15,
                              lineHeight: '22.5px',
                              color: 'rgba(70, 78, 95, 1)',
                              padding: '20px'
                            }}
                            colSpan="6"
                          >
                            Aucun Expert disponible
                          </TableCell>
                        </tr>
                      )}
                    </>
                  )}
              </tbody>
          </Table>
          <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                count={inspectorsFilter?.length || 0}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page",
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page",
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px",
                  color: "rgba(32, 18, 70, 1)",
                }}
                labelRowsPerPage="Lignes par page"
            />
        </div>
      </Paper>

      <Dialog
            open={open}
            onClose={handleAddExpert}
            classes={{ paper: classes.dialogPaper }}
          >
            <DialogTitle
              className={classes.dialogTitle}
              style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
            >
              {isEditing ? "Modification Expert" : "Création Expert"}
            </DialogTitle>
            <DialogContent>
            <Accordion allowMultiple defaultIndex={[0, 1, 2 , 3]}> {/* All panels open by default */}
              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(187, 200, 8, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Informations générales
                  </Box>
                </AccordionButton>
                  <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                   <div style={{display:"flex" ,justifyContent: "space-between"}}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Nom Expert
                        </label>
                        <input
                          className={classes.styleInput}
                          value={firstName}
                          disabled={detail}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setFirstName(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                          name='NomExpert'
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Prénom Expert
                        </label>
                        
                         <input
                          className={classes.styleInput}
                          value={lastName}
                          disabled={detail}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setLastName(e.target.value)
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                          name='PrénomExpert'
                        />
                      </div>
                   </div>
                   <div style={{display:"flex",justifyContent: "space-between" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          N° Tél
                        </label>
                        <input
                          type="text"
                          className={classes.styleInput}
                          value={phoneNumber}
                          disabled={detail}
                          onChange = {handlePhoneNumberChange}
                          name='phone'
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className={classes.styleInput}
                          value={email}
                          disabled={detail}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setEmail(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                          name='Email'
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                   </div>
                   <div style={{display:"flex",justifyContent: "space-between" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Identité
                        </label>
                        <input 
                          className={classes.styleInput}
                          value={identity}
                          disabled={detail}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setIdentity(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                          name='Identité'
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label
                          className={classes.cardText}
                          style={{ marginBottom: "0.5rem" }}
                        >
                          Code TVA
                        </label>
                        <input 
                          className={classes.styleInput}
                          value={codeTVA}
                          disabled={detail}
                          onChange={(e) => {
                            if (validateInput(e.target.value)) {
                              setCodeTVA(e.target.value);
                              setErrors([]);
                            } else {
                              setErrors(["Les caractères spéciaux ne sont pas autorisés."]);
                            }
                          }}
                          name='CodeTVA'
                        />
                        <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
                      </div>
                   </div>
                  </div>
                </AccordionPanel> 
              </AccordionItem>

              <AccordionItem>
                  <AccordionButton
                    style={{
                      height: "47px",
                      border: "none",
                      background: "rgba(255, 255, 255, 1)",
                      borderBottom: "none",
                    }}
                  >
                    <AccordionIcon
                      size="30px"
                      style={{
                        backgroundColor: "rgba(240, 243, 199, 1)",
                        width: "25px",
                        height: "25px",
                        borderRadius: "5px",
                        color: "rgba(187, 200, 8, 1)",
                      }}
                    />
                    <Box
                      as="div"
                      textAlign="left"
                      marginLeft="20px"
                      style={{
                        color: "rgba(0, 34, 38, 1)",
                        fontSize: "14px",
                        fontWeight: 500,
                        lineHeight: "21px",
                        fontFamily: "Poppins",
                      }}
                    >
                      Périmétre de gestion
                    </Box>
                  </AccordionButton>
                  <AccordionPanel>
                    <div style={{ marginLeft: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginBottom: "1rem",
                        }}
                      >
                        <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>
                          Typologie de sinistre
                        </label>
                          <Autocomplete
                              multiple
                              id="management"
                              name="management"
                              options={managementTypes}
                              value={selectedManagementTypes}
                              disabled={detail}
                              size="small"
                              onChange={handleManagementTypesChange}  
                              getOptionLabel={(option) => option.label}
                              renderOption={(props, option) => (
                                <li {...props} className={`${props.className} ${classes.optionItem}`}>
                                  {option.label}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    placeholder: selectedManagementTypes && selectedManagementTypes.length<1 ?'Typologie de sinistre':'',
                                    endAdornment: null,
                                    classes: {
                                      root: classes.selectInputDialog,
                                    },
                                  }}
                                />
                              )}
                              sx={{
                                fontFamily: 'Poppins, sans-serif',
                                '& .MuiOutlinedInput-root': {
                                  p: 1,
                                  height: 'fit-content',
                                  backgroundColor: 'rgba(243, 246, 249, 1)',
                                  fontSize: '0.75rem',
                                  display: 'flex',
                                  fontFamily: 'Poppins',
                                  border: 'none',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  '& fieldset': {
                                    border: 'none',
                                  },
                                },
                                '& .MuiAutocomplete-popupIndicator': {
                                  display: 'none',
                                },
                                '& .MuiAutocomplete-tag': {
                                  bgcolor: 'rgba(240, 243, 199, 1)',
                                  color: 'rgba(60, 101, 86, 1)',
                                  border: 'none',
                                  borderColor: 'primary.light',
                                  fontSize: '0.75rem',
                                  padding: '2px 6px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  margin: '2px',
                                },
                                '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
                                  color: 'rgba(60, 101, 86, 1)',
                                  '&:hover': {
                                    color: 'rgba(60, 101, 86, 1)',
                                  },
                                },
                              }}
                              isOptionEqualToValue={(option, value) => option.label === value.label}
                            />
                      </div>

                      
                    </div>
                  </AccordionPanel> 
              </AccordionItem>
              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(187, 200, 8, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Gouvernorat / Région
                  </Box>
                </AccordionButton>
                <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                    {/* Governorates Selection */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Gouvernorat
                      </label>
                      <Autocomplete
                        multiple
                        id="Governorates"
                        options={governorates}
                        value={selectedGovernorates}
                        disabled={detail}
                        size="small"
                        onChange={handleGovernorates}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            className={`${props.className} ${classes.optionItem}`}
                          >
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              placeholder:
                                selectedGovernorates && selectedGovernorates.length < 1
                                  ? "Sélectionnez Gouvernorat"
                                  : "",
                            }}
                          />
                        )}
                        sx={{
                          fontFamily: 'Poppins, sans-serif',
                          '& .MuiOutlinedInput-root': {
                            p: 1,
                            height: 'fit-content',
                            backgroundColor: 'rgba(243, 246, 249, 1)',
                            fontSize: '0.75rem',
                            display: 'flex',
                            fontFamily: 'Poppins',
                            border: 'none',
                            alignItems: 'center',
                            justifyContent: 'center',
                            '& fieldset': {
                              border: 'none',
                            },
                          },
                          '& .MuiAutocomplete-popupIndicator': {
                            display: 'none',
                          },
                          '& .MuiAutocomplete-tag': {
                            bgcolor: 'rgba(240, 243, 199, 1)',
                            color: 'rgba(60, 101, 86, 1)',
                            border: 'none',
                            borderColor: 'primary.light',
                            fontSize: '0.75rem',
                            padding: '2px 6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '2px',
                          },
                          '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
                            color: 'rgba(60, 101, 86, 1)',
                            '&:hover': {
                              color: 'rgba(60, 101, 86, 1)',
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option.label === value.label}
                      />
                    </div>

                    {/* Delegations Selection */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label
                        className={classes.cardText}
                        style={{ marginBottom: "0.5rem" }}
                      >
                        Région
                      </label>
                      <Autocomplete
                        multiple
                        id="Delegations"
                        options={delegationsOptions.map((delegation) => ({
                          label: delegation,
                        }))}
                        disabled={detail}
                        value={selectedDelegations}
                        size="small"
                        onChange={handleDelegations}
                        isOptionEqualToValue={(option, value) => option.label === value.label}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            className={`${props.className} ${classes.optionItem}`}
                          >
                            {option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              placeholder:
                                delegationsOptions && delegationsOptions.length < 1
                                  ? "Sélectionnez Région"
                                  : "",
                            }}
                          />
                        )}
                        sx={{
                          fontFamily: 'Poppins, sans-serif',
                          '& .MuiOutlinedInput-root': {
                            p: 1,
                            height: 'fit-content',
                            backgroundColor: 'rgba(243, 246, 249, 1)',
                            fontSize: '0.75rem',
                            display: 'flex',
                            fontFamily: 'Poppins',
                            border: 'none',
                            alignItems: 'center',
                            justifyContent: 'center',
                            '& fieldset': {
                              border: 'none',
                            },
                          },
                          '& .MuiAutocomplete-popupIndicator': {
                            display: 'none',
                          },
                          '& .MuiAutocomplete-tag': {
                            bgcolor: 'rgba(240, 243, 199, 1)',
                            color: 'rgba(60, 101, 86, 1)',
                            border: 'none',
                            borderColor: 'primary.light',
                            fontSize: '0.75rem',
                            padding: '2px 6px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '2px',
                          },
                          '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
                            color: 'rgba(60, 101, 86, 1)',
                            '&:hover': {
                              color: 'rgba(60, 101, 86, 1)',
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option.label === value.label}
                      />
                    </div>
                  </div>
                </AccordionPanel> 
              </AccordionItem>

              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(187, 200, 8, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Typologies des mission
                  </Box>
                </AccordionButton>
                 <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "1rem",
                      }}
                    >
                      <label className={classes.cardText} style={{ marginBottom: "0.5rem" }}>
                        Type de mission
                      </label>
                      <Autocomplete
                        multiple
                        id="Authorities"
                        name="Authorities"
                        options={typologies}
                        value={selectedTypologie}
                        size="small"
                        disabled={detail}
                        onChange={handleTypologieChange}
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => (
                          <li
                            {...props}
                            className={`${props.className} ${classes.optionItem}`}
                          >
                            { option.label}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              disableUnderline: true,
                              placeholder: selectedTypologie&& selectedTypologie.length<1 ?'Typologie de sinistre':'',
                              endAdornment: null,
                              classes: {
                                root: classes.selectInputDialog,
                              },
                            }}
                          />
                        )}
                        sx={{
                          fontFamily: "Poppins, sans-serif",
                          "& .MuiOutlinedInput-root": {
                            p: 1,
                            height: "fit-content",
                            backgroundColor: "rgba(243, 246, 249, 1)",
                            fontSize: "0.75rem",
                            display: "flex",
                            fontFamily: "Poppins",
                            border: "none",
                            alignItems: "center",
                            justifyContent: "center",
                            "& fieldset": {
                              border: "none",
                            },
                          },
                          "& .MuiAutocomplete-popupIndicator": {
                            display: "none",
                          },
                          "& .MuiAutocomplete-tag": {
                            bgcolor: "rgba(240, 243, 199, 1)",
                            color: "rgba(60, 101, 86, 1)",
                            border: "none",
                            borderColor: "primary.light",
                            fontSize: "0.75rem",
                            padding: "2px 6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "2px",
                          },
                          "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                            color: "rgba(60, 101, 86, 1)",
                            "&:hover": {
                              color: "rgba(60, 101, 86, 1)",
                            },
                          },
                        }}
                        isOptionEqualToValue={(option, value) => option.label === value.label}

                      />
                    </div>
                  </div>
                </AccordionPanel> 
              </AccordionItem> 

            </Accordion>

            </DialogContent>
            {detail ? <></>: ( <DialogActions>
              <Button style={{
                                    fontFamily: 'Poppins',
                                    fontSize: '10.76px',
                                    fontWeight: 600,
                                    lineHeight: '16.14px',
                                    textAlign: 'left',
                                    color: 'rgba(255, 54, 54, 1)',
                                    background: 'rgba(255, 229, 229, 1)',
                                    width: '62px',
                                    height: '26px',
                                    borderRadius: '5.38px',
                                    marginRight: '10px',
                                    '&:hover': {
                                        background: 'rgba(255, 229, 229, 1)',
                                    },
                                }}
                                onClick={handleAddExpert} 
                                color="secondary">
                Annuler
              </Button>
              <Button name ="Valider" style={{
                                    fontFamily: 'Poppins',
                                    fontSize: '10.76px',
                                    fontWeight: 600,
                                    lineHeight: '16.14px',
                                    textAlign: 'left',
                                    color: 'rgba(255, 255, 255, 1)',
                                    background: 'rgba(60, 101, 86, 1)',
                                    width: '61.08px',
                                    height: '26.71px',
                                    borderRadius: '5.38px',
                                    marginRight: "10px",
                                    '&:hover': {
                                        background: 'rgba(187, 200, 8, 1)',
                                    },
                                }}
                                   onClick={isEditing ?handleSubmitEdit: handleSubmitAdd }
                                disabled={isRequestInProgress}
                                color="primary">
                {isEditing ? "Modifier" : "Valider"}
              </Button>
            </DialogActions>)}
           
      </Dialog>

      <Dialog
        open={openConfirm}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseConfirm}
        aria-describedby="alert-dialog-slide-description"
    >
        <DialogTitle
        className={classes.dialogTitle}
        style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
        >
        {"Confirmation de suppression"}
        </DialogTitle>
        <DialogContent>
        <DialogContentText
            id="alert-dialog-slide-description"
            style={{
            fontFamily: "Poppins",
            fontSize: "16px",
            }}
        >
            Êtes-vous sûr de supprimer Expert <br />«{" "}
            {expertToDelete?.personDetails?.name}{" "}{expertToDelete?.personDetails?.lastName} »
            <br /> 
        </DialogContentText>
        </DialogContent>
        <DialogActions>
        <Button
            onClick={handleCloseConfirm}
            style={{
            fontFamily: "Poppins",
            fontSize: "10.76px",
            fontWeight: 600,
            lineHeight: "16.14px",
            textAlign: "left",
            color: "rgba(255, 255, 255, 1)",
            background: "rgba(60, 101, 86, 1)",
            width: "fit-content",
            height: "26px",
            borderRadius: "5.38px",
            marginRight: "10px",
            }}
        >
            Annuler
        </Button>
        <Button
            onClick={handleConfirmDelete}
            style={{
            fontFamily: "Poppins",
            fontSize: "10.76px",
            fontWeight: 600,
            lineHeight: "16.14px",
            textAlign: "left",
            color: "rgba(255, 54, 54, 1)",
            background: "rgba(255, 229, 229, 1)",
            width: "fit-content",
            height: "26.71px",
            borderRadius: "5.38px",
            marginRight: "10px",
            }}
        >
            Supprimer
        </Button>
        </DialogActions>
      </Dialog>

       <Dialog
          open={openUnlockDialog}
          onClose={handleCloseUnlockDialog}
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle
            className={classes.dialogTitle}
            style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
          >
            Déverrouiller le compte
          </DialogTitle>
          <DialogContent>
            <Accordion allowMultiple defaultIndex={[0]}>
              <AccordionItem>
                <AccordionButton
                  style={{
                    height: "47px",
                    border: "none",
                    background: "rgba(255, 255, 255, 1)",
                    borderBottom: "none",
                  }}
                >
                  <AccordionIcon
                    size="30px"
                    style={{
                      backgroundColor: "rgba(240, 243, 199, 1)",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      color: "rgba(60, 101, 86, 1)",
                    }}
                  />
                  <Box
                    as="div"
                    textAlign="left"
                    marginLeft="20px"
                    style={{
                      color: "rgba(0, 34, 38, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "21px",
                      fontFamily: "Poppins",
                    }}
                  >
                    Déverrouillage du compte
                  </Box>
                </AccordionButton>
                <AccordionPanel>
                  <div style={{ marginLeft: "1rem" }}>
                    <div
                      style={{
                        marginBottom: "1rem",
                        fontFamily: "Poppins",
                        fontSize: "13px",
                        color: "rgba(70, 78, 95, 1)",
                      }}
                    >
                      Ce compte est actuellement verrouillé. En confirmant, le
                      compte sera débloqué et le nombre de tentatives sera
                      réinitialisé. Un email avec le nouveau mot de passe sera envoyé à l'utilisateur.
                    </div>
                  </div>
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          <ErrorsAlert open={errors.length > 0} errors={errors} handleClose={() => setErrors([])} />
          </DialogContent>
          <DialogActions>
            <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 54, 54, 1)",
                background: "rgba(255, 229, 229, 1)",
                width: "62px",
                height: "26px",
                borderRadius: "5.38px",
                marginRight: "10px",
              }}
              onClick={handleCloseUnlockDialog}
              color="secondary"
            >
              Annuler
            </Button>
            <Button
              style={{
                fontFamily: "Poppins",
                fontSize: "10.76px",
                fontWeight: 600,
                lineHeight: "16.14px",
                textAlign: "left",
                color: "rgba(255, 255, 255, 1)",
                background: "rgba(60, 101, 86, 1)",
                width: "80px",
                height: "26.71px",
                borderRadius: "5.38px",
                marginRight: "10px",
              }}
              onClick={handleConfirmUnlock}
              color="primary"
            >
              Confirmer
            </Button>
          </DialogActions>
        </Dialog>
          {isRequestInProgress && (
                <div
                    style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",  // Center vertically
                    }}
                >
                    <div
                    style={{
                        background: "#fff",
                        padding: "20px",
                        borderRadius: "8px",
                        textAlign: "center",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        display: "flex",           // Use flexbox
                        flexDirection: "column",   // Stack the loader and text vertically
                        justifyContent: "center",  // Vertically center content inside the box
                        alignItems: "center",      // Horizontally center content inside the box
                    }}
                    >
                    <div className="spinner" style={{ marginBottom: "10px" }}></div>  {/* Optional margin between loader and text */}
                    <p style={{ fontFamily: "Poppins", fontSize: "16px", margin: 0 }}>
                        Veuillez patienter...
                    </p>
                    </div>
                </div>
            )}
    </div>
  );
}
